import Env from '../base/env';
import Component from 'gia/Component';
import { RevealFadeX } from '../fx/Common'

export default class FxModule extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element

    //? Fns
    setTimeout(() => {
      RevealFadeX(this.DOM.view)
    }, Env.timingDelayFx);
  }
}
